import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import {
    postApiWithAuthorization,
    getApiWithAuthorization,
} from "../ApiMethod/ApiMethod";

export const GetBenefitLookupList = async (AppLangID) => {
    const url = `${NewUpdatedBaseUrl}/Benefit/GetBenefitLookupList?AppLangID=${AppLangID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};
export const GetDeityLookupList = async (AppLangID) => {
    const url = `${NewUpdatedBaseUrl}/Deity/GetDeityLookupList?AppLangID=${AppLangID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};